<!--
    课件统计
-->
<template>
    <div class="page userPage">
        <el-row :gutter="20">
            <el-col :span="6">
                <statistics-multi-orgs @orgsChange="orgsChange" @dataLoaded="orgDataLoaded"></statistics-multi-orgs>
            </el-col>
            <el-col :span="18">
                <ui-card :title="$t('course.type')" icon="nucfont inuc-menu-assemble" class="ibox">
                    <el-row class="content_detail">
                        <el-col class="resource-type">
                            <div class="theory-style" @click="btnSourceType('theory')">
                                <p class="img-num">{{theoryNum}}</p>
                                <p class="img-type">{{theoryName}}</p>
                                <p class="rate">{{theoryRate}}</p>
                            </div>
                        </el-col>
                        <el-col class="resource-type">
                            <div class="DR-style" @click="btnSourceType('DR')">
                                <p class="img-num">{{DRNum}}</p>
                                <p class="img-type">{{DRName}}</p>
                                <p class="rate">{{DRRate}}</p>
                            </div>
                        </el-col>
                        <el-col class="resource-type">
                            <div class="CT-style" @click="btnSourceType('CT')">
                                <p class="img-num">{{CTNum}}</p>
                                <p class="img-type">{{CTName}}</p>
                                <p class="rate">{{CTRate}}</p>
                            </div>
                        </el-col>
                    </el-row>
                </ui-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col>
                <ui-card :title="$t('c.knowledgePoint')+'('+courseType+')'" icon="nucfont inuc-pie-chart"
                         class="ibox">
                    <el-row class="content_detail">
                        <el-col class="resource-type">
                            <el-card>
                                <div v-show="knowledgePieShow" id="courseKnowledgePie"
                                     class="knowledgeBox"></div>
                                <p v-show="!knowledgePieShow" class="emptyBox"><i
                                    class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                            </el-card>
                        </el-col>
                    </el-row>
                </ui-card>
            </el-col>
        </el-row>
        <el-row :gutter="20" v-for="(item,index) in items" :key="index">
            <statistics-upload-top :ref="item.id"
                                   :statisticName="item.titleName"
                                   :id="item.id"
                                   :sourceType="courseType"
                                   :legendName="item.legendName"></statistics-upload-top>
        </el-row>
    </div>
</template>
<script>
    import api from '@/api';
    import {mapGetters} from 'vuex';
    import {Debounce} from '@/utils';
    import StatisticsMultiOrgs from '@/components/Statistics/StatisticsMultiOrgs';
    import StatisticsUploadTop from "@/components/Statistics/StatisticsUploadTop";
    import uiCard from '@/components/Statistics/StatisticUICard.vue';

    var echarts = require('echarts');
    export default {
        data() {
            return {
                searchData: {
                    orgIds: [],
                    type: undefined,
                },
                items: [
                    {
                        titleName: this.$t('count.courseNum') + '(TOP10)',
                        id: 'courseAmount',
                        legendName: this.$t('count.uploadNum')
                    },
                    {
                        titleName: this.$t('count.frequency') + '(TOP10)',
                        id: 'courseUseTop',
                        legendName: this.$t('count.frequency')
                    }
                ],
                courseType: this.$t('c.all'),
                theoryName: '',
                DRName: '',
                CTName: '',
                theoryNum: 0,
                DRNum: 0,
                CTNum: 0,
                theoryRate: '0%',
                DRRate: '0%',
                CTRate: '0%',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                knowledgePieShow: false,
                uploadOrderShow: false,

                uploadData: [],
                isTheory: false,
                isDR: false,
                isCT: false,
            };
        },
        created() {
        },
        mounted() {
            this.orgsChange();
        },
        computed: {
            ...mapGetters([
                'orgTree',
            ])
        },
        methods: {
            orgDataLoaded() {
                $('.el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();
            },
            btnSourceType(value) {
                if (value === 'theory') {
                    this.isTheory = !this.isTheory;
                    this.isDR = false;
                    this.isCT = false;
                    if (this.isTheory) {
                        this.searchData.type = 'Theory';
                        this.courseType = this.$t('count.theory');
                    } else {
                        this.searchData.type = undefined;
                        this.courseType = this.$t('c.all');
                    }
                }
                if (value === 'DR') {
                    this.isTheory = false;
                    this.isDR = !this.isDR;
                    this.isCT = false;
                    if (this.isDR) {
                        this.searchData.type = 'DR';
                        this.courseType = 'DR';
                    } else {
                        this.searchData.type = undefined;
                        this.courseType = this.$t('c.all');
                    }
                }
                if (value === 'CT') {
                    this.isTheory = false;
                    this.isDR = false;
                    this.isCT = !this.isCT;
                    if (this.isCT) {
                        this.searchData.type = 'CT';
                        this.courseType = 'CT';
                    } else {
                        this.searchData.type = undefined;
                        this.courseType = this.$t('c.all');
                    }
                }
                this.courseWareNum(this.searchData);
                this.courseWareUseTop(this.searchData);
                this.courseKnowledgeTip(this.searchData);
            },
            orgsChange: Debounce(function (data) {
                this.courseType = this.$t('c.all');
                this.searchData.orgIds = data;
                let searchData = {
                    orgIds: this.searchData.orgIds,
                    type: undefined
                };
                this.getType(searchData);
                this.courseWareNum(searchData);
                this.courseWareUseTop(searchData);
                this.courseKnowledgeTip(searchData);
            }, 600),
            getType(data) {
                api.getCourseWareByType(data).then((res) => {
                    if (res.package.length > 0) {
                        this.theoryName = res.package[0].name;
                        this.DRName = res.package[1].name;
                        this.CTName = res.package[2].name;
                        this.theoryNum = res.package[0].value;
                        this.DRNum = res.package[1].value;
                        this.CTNum = res.package[2].value;
                        let total = this.theoryNum + this.DRNum + this.CTNum;
                        this.theoryRate = total == 0 ? ('0.00%') : (Math.round(this.theoryNum / total * 10000) / 100 + "%");
                        this.DRRate = total == 0 ? ('0.00%') : (Math.round(this.DRNum / total * 10000) / 100 + "%");
                        this.CTRate = total == 0 ? ('0.00%') : (Math.round(this.CTNum / total * 10000) / 100 + "%");
                    }
                })
            },
            courseKnowledgeTip(queryData) {
                let knowledgeChart = echarts.init(document.getElementById("courseKnowledgePie"));
                //制定图标的配置项和数据
                knowledgeChart.showLoading();
                let obj = {};
                obj.name = this.$t('c.knowledgePoint');
                api.getCourseWareByKnowLedge(queryData).then((res) => {
                    if (res.package.length > 0) {
                        this.knowledgePieShow = true;
                        let knowledgeData = res.package;
                        knowledgeData.forEach(item => {
                            if (!item.value) {
                                item.label = {
                                    show: false
                                };
                                item.labelLine = {
                                    show: false
                                }
                            }
                        });
                        let legendData = [];
                        [...knowledgeData].forEach(value => {
                            legendData.push(value.name);
                        });

                        Object.assign(obj, {
                            knowledgeData,
                            legendData
                        });
                        //制定图标的配置项和数据
                        let option = getPieOption(obj);
                        knowledgeChart.setOption(option);
                        knowledgeChart.hideLoading();
                    } else {
                        knowledgeChart.hideLoading();
                        this.knowledgePieShow = false;
                    }

                    function getPieOption({
                                              legendOrient = 'vertical',
                                              legendX = 'right',
                                              legendData = [],
                                              name = '',
                                              knowledgeData = []
                                          }) {
                        let options = {
                            color: ['#59a4cb', '#f18d82', '#f2d989', '#37b7c5', '#998b7e', '#ab85e8', '#6a7882', '#c1837f', '#d2a470', '#43a7de', '#ac628d', '#a89a69', '#496c99', '#c478b7', '#7c6d77'],
                            tooltip: {
                                trigger: 'item',
                                formatter: '{a}<br/>{b}:{c}({d}%)'
                            },
                            legend: {
                                type: 'scroll',
                                icon: 'rect',
                                itemWidth: 25,
                                itemHeight: 4,
                                orient: legendOrient,
                                right: 0,
                                data: legendData,
                                pageButtonGap: 15,
                                pageButtonItemGap: 15,
                                pageIconSize: [10, 10],
//                                formatter: function (name) {
//                                    return name.length > 4 ? name.substr(0, 4) + "..." : name;
//                                },
                            },
                            series: [
                                {
                                    name: name,
                                    type: 'pie',
                                    center: ['40%', '55%'],
                                    data: knowledgeData,
                                    label: {
                                        formatter: function (event) {
                                            return event.name.length > 23 ? event.name.substr(0, 23) + "..." : event.name;
                                        },
                                    }
                                }
                            ],
                        };

                        return options;
                    }
                })
            },
            courseWareNum(data) {
                let _this = this;
                api.getCourseWareUpLoadCount(data).then((res) => {
                    if (res.package) {
                        _this.uploadFunction(res.package, 'courseAmount')
                    } else {
                        _this.uploadFunction([])
                    }
                });
            },
            courseWareUseTop(data) {
                let _this = this;
                api.getCourseWareUsedTimes(data).then((res) => {
                    if (res.package) {
                        _this.uploadFunction(res.package, 'courseUseTop')
                    } else {
                        _this.uploadFunction([])
                    }
                });
            },
            uploadFunction(data, id) {
                // 父组件多次同一个子组件，调用子组件函数时应加上唯一的标识（id）
                this.$refs[id][0] && this.$refs[id][0].upLoadSeption(data, id);
            }
        },
        watch: {},
        components: {
            StatisticsUploadTop,
            StatisticsMultiOrgs,
            uiCard
        }
    };
</script>
<style scoped lang="scss">
    @import '../../style/const';

    .page {
        & /deep/ .el-card {
            border: none;
        }
        & /deep/ .el-card.is-always-shadow {
            box-shadow: none;
        }
        & /deep/ .el-card__body {
            padding: 20px 0;
        }
    }

    .ibox {
        .content_detail {
            padding: 20px;
            display: flex;
            .resource-type {
                flex: 1;
                margin: 0 3px;
                .knowledgeBox {
                    width: 1000px;
                    height: 330px;
                    margin: auto;
                }
                .emptyBox {
                    text-align: center;
                    height: 330px;
                    line-height: 330px;
                }
                .theory-style,
                .DR-style,
                .CT-style {
                    width: 100%;
                    height: 110px;
                    margin: 60px auto;
                    cursor: pointer;
                    position: relative;
                    p {
                        color: #fff;
                        text-align: center;
                        &.rate {
                            position: absolute;
                            bottom: 10px;
                            right: 15px;
                            font-size: 20px;
                        }
                        &.img-num {
                            font-size: 30px;
                            padding: 15px 0 5px;
                        }
                        &.img-type {
                            font-size: 20px;
                            letter-spacing: 2px;
                        }
                    }
                }
                .theory-style {
                    background: #589fd5;
                    background-image: url(../../assets/images/statistic/bg_statistic_blue.jpg);
                    background-size: cover;
                }
                .DR-style {
                    background: #fab160;
                    background-image: url(../../assets/images/statistic/bg_statistic_yellow.jpg);
                    background-size: cover;
                }
                .CT-style {
                    background: #eb7162;
                    background-image: url(../../assets/images/statistic/bg_statistic_pink.jpg);
                    background-size: cover;
                }
            }
        }
    }
</style>


